'use client'

import { createContext } from 'react';

export const CsrfTokenContext = createContext<string | null>(null);

export function CsrfProvider({ children, value }: React.PropsWithChildren<{ value: string | null }>) {
  return (
    <CsrfTokenContext.Provider value={value}>
      {children}
    </CsrfTokenContext.Provider>
  )
}